import { IProfileTabItem } from '../models/IProfileMenu'

const ProfileTabList: IProfileTabItem[] = [
  { name: 'On sale', tabUrl: 'on-sale' },
  { name: 'Collection', tabUrl: 'collection' },
  { name: 'Activity', tabUrl: 'activity', noCount: true }
]

export default ProfileTabList
